import {useSelector} from 'react-redux'

/**
 * Custom React Hook to get count value from state.
 * @see https://reactjs.org/docs/hooks-custom.html
 */
const useFullListData = () => useSelector(state => state.fullList)

export default useFullListData
